export default function DatasetInfoPanel() {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Dataset Information</h2>

      <div className="space-y-6 text-xs">
        <div>
          <h3 className="text-sm font-medium text-gray-500">Description</h3>
          <p className="mt-1">
            This dataset contains test cases for evaluating AI chat responses
            across different scenarios.
          </p>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500">Metadata</h3>
          <div className="mt-2 space-y-2">
            <div className="flex justify-between text-xs">
              <span>Total Test Cases:</span>
              <span className="font-medium">3</span>
            </div>
            <div className="flex justify-between text-xs">
              <span>Last Updated:</span>
              <span className="font-medium">March 15, 2024</span>
            </div>
            {/* Add more metadata fields as needed */}
          </div>
        </div>
      </div>
    </div>
  );
}
